import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';
export const RoleGroupPDF = ({
  roleGroup
}) => /*#__PURE__*/React.createElement(View, {
  style: styles.width20
}, /*#__PURE__*/React.createElement(Text, {
  key: roleGroup,
  style: styles.CPFTableDetailsText
}, roleGroup));